export default __webpack_public_path__ + "static/media/upload-logo.fd027108.svg";